// extracted by mini-css-extract-plugin
export default {"block":"x1oOKCIpZLZomwa7spHe"};